var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "720.000000pt",
    height: "405.000000pt",
    viewBox: "0 0 720.000000 405.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,405.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3320 3606 c-374 -66 -688 -240 -939 -522 -172 -193 -304 -454 -362 -713 -32 -146 -44 -331 -31 -475 21 -224 66 -385 162 -581 68 -139 141 -249 237 -355 232 -257 502 -417 839 -497 113 -26 131 -28 344 -28 193 1 239 4 322 22 202 46 389 125 563 240 136 91 337 292 428 428 246 373 330 808 237 1242 -64 304 -205 560 -434 789 -230 229 -476 365 -788 435 -119 27 -460 36 -578 15z m231 -407 c136 -46 188 -207 107 -330 -29 -44 -117 -89 -173 -89 -24 0 -62 11 -94 26 -155 78 -155 300 0 378 57 28 106 33 160 15z m149 -1339 l0 -760 145 0 145 0 0 -130 0 -130 -420 0 -420 0 0 130 0 130 145 0 145 0 0 630 0 630 -125 0 -125 0 0 130 0 130 255 0 255 0 0 -760z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.5474b53b1d395615be6c06e092f3efbe.svg";
export { ForwardRef as ReactComponent };